<template>
  <v-card class="player-btn pl-2 pr-2 theme-border theme-background" flat depressed tile large
          :class="[isCurrentGoalKeeper ? 'actual-goalkeeper' : '', isExcluded ? 'isExcluded' : '']">

    <v-card flat tile class="player-number mr-2 text-no-wrap transparent" v-if="player.jersey">
      {{ player.jersey }}
    </v-card>

    <v-card flat tile class="flex-grow-1 player-name text-truncate transparent" v-if="player && player.name">
      {{ player.name.toLowerCase() }}
    </v-card>
    <v-card flat tile class="flex-grow-1 player-name text-truncate transparent" v-else>
      Nincs megjeleníthető név
    </v-card>

    <v-card flat tile class="d-inline-flex player-cards text-no-wrap align-center transparent">

      <v-card v-if="playerStats.goals > 0" flat tile class="d-inline-flex goals-shot text-no-wrap ml-1 transparent">
        <img class="goals-shot-gate" src="/icons/gate_mini.svg" alt=""/>
        <div style="color: #9298AF;">{{ playerStats.goals }}</div>
      </v-card>

      <PlayerPenalty :player="player" ref="penaltyComponent"/>

      <template v-if="this.gamedata.rule === 'STRAND'">
        <PlayerCard :show="playerStats.showStrandYellow1" type="K" color="red" tooltip="Kiállítás"/>
        <PlayerCard :show="playerStats.showStrandYellow2" type="K" color="red" tooltip="Kiállítás"/>

        <PlayerCard :show="playerStats.yellow" type="S" color="yellow darken-3" tooltip="Sárga lap"/>
        <PlayerCard :show="playerStats.red" type="P" color="red darken-2" tooltip="Piros lap"/>
        <PlayerCard :show="playerStats.blue" type="K" color="blue darken-1" tooltip="Kék lap"/>
      </template>
      <template v-else>
        <PlayerCard :show="playerStats.yellow" type="S" color="yellow darken-3" tooltip="Sárga lap"/>
        <PlayerCard :show="playerStats.red" type="P" color="red darken-2" tooltip="Piros lap"/>
        <PlayerCard :show="playerStats.blue" type="K" color="blue darken-1" tooltip="Kék lap"/>
      </template>

      <v-card flat tile class="transparent" v-if="player.goalkeeper"
              @click.stop.prevent="openGoalKeeperLocalMenu($event)">
        <v-icon class="theme-hightext">mdi-swap-vertical</v-icon>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import Bugsnag from "@bugsnag/js";

var debug = require('debug')('MKSZ:PlayerPenalty');
import PlayerCard from "./PlayerCard";
import PlayerPenalty from "./PlayerPenalty";
import eventBus from '@/eventBus';
import CONSTANTS from "../constants";
import TimeFormatter from "@/TimeFormatter";
import {mapGetters, mapState} from "vuex";

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: 'Player',
  components: {
    PlayerCard,
    PlayerPenalty,
  },
  props: ['player', 'teamid', 'gamedata'],
  data: function () {
    return {
      score: 0,
      showStrandYellowsOld: {
        1: false,
        2: false,
      },
    };
  },
  mounted() {
    let self = this;

    // A `$refs` az nem globális, nekem viszont kell a validálásos metódusokhoz hozzáférés
    window.players = window.players || {};
    window.players[this.player.id] = this;


    /**
     * Kiállítás törlés lokális kezelése
     *
     * @param  Object event A kitörlendő rekord
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.PENALTIES.TAKE, function (event) {
      if (self.player.id === event.params.selectedPlayer) {
        self.player.penalties = self.player.penalties.filter((penalty) => {
          return penalty.UUID !== event.UUID;
        });
        // --- JAVÍTÁS ITT: Biztonsági ellenőrzés hozzáadása ---
        if (self.$refs.penaltyComponent && typeof self.$refs.penaltyComponent.checkWatch === 'function') {
          self.$refs.penaltyComponent.checkWatch();
        } else {
          console.warn("[Player.vue] checkWatch hívása sikertelen: penaltyComponent ref nem elérhető.");
        }
        // --- JAVÍTÁS VÉGE ---

        // Saját kiállítás törlésekor a piros lapokat törölni kell
        if (self.player.cards.red.value && self.player.cards.red.auto) {
          eventBus.$emit(CONSTANTS.EVENTS.RECORD.DELETE, self.player.cards.red.UUID);
        }
      } else if (self.player.id === event.params.selectedScapegoat) {
        self.player.penalties = self.player.penalties.filter((penalty) => {
          return penalty.real !== event.params.selectedPlayer;
        });
        // --- JAVÍTÁS ITT: Biztonsági ellenőrzés hozzáadása ---
        if (self.$refs.penaltyComponent && typeof self.$refs.penaltyComponent.checkWatch === 'function') {
          self.$refs.penaltyComponent.checkWatch();
        } else {
          console.warn("[Player.vue] checkWatch hívása sikertelen: penaltyComponent ref nem elérhető.");
        }
        // --- JAVÍTÁS VÉGE ---
      }
    });


    /**
     * Strand sárga adás lokális kezelése
     *
     * A várt event struktúrája:
     * * player: Játékos object, aki ki lett állítva
     *
     * @param  Object event Object ami tartalmazza a fenti struktúrát
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.GIVE.STRAND_YELLOW, (event) => {
      if (this.player.id !== event.player.id) {
        return;
      }

      if (event.time === undefined) {
        event.time = window.stopwatch.getTotalTime(); // Mikor kapta a lapot
      }
      this.player.strandYellows.push({
        UUID: event.UUID,
      });

      // A megjelenítésért felelős
      //this.recalculatePlayerStrandYellows();

      // Ha kigyűlt a 2 strand sárga és még nincs piros lapja, akkor kap egyet
      if (this.player.strandYellows.length == 2 && !this.player.cards.red.value) {
        // Egy új eventet csinálunk
        let newEvent = {
          action: 'piroslap',
          isDraft: false,
          totalGameTime: window.stopwatch.getTotalTime(),
          params: {
            time: event.time,
            gametime: event.time, // ???
            gameTime: window.stopwatch.getTotalTimeAsString(),
            totalGameTime: window.stopwatch.getTotalTime(),
            auto: true,
            selectedPlayer: event.player.id,
            selectedTeamId: event.player.team,
            teamScore: {
              teamA: window.gamedata.team_a_score,
              teamB: window.gamedata.team_b_score,
            },
            isDraft: false,
            selectedAction: {
              actionId: 'piroslap',
              actionName: 'Piros lap (auto)',
            },
          },
        };

        // És elmentjük
        window.dbmanager.write(newEvent).then((result) => {
          if (result) {
            window.dbmanager.read(result).then((record) => {
              eventBus.$emit(CONSTANTS.EVENTS.RECORD.PUSH, record);

              // Egy piros lapot kiállítunk frontenden
              eventBus.$emit(CONSTANTS.ACTIONS.CARDS.GIVE.RED, {
                player: this.player,
                auto: true,
                UUID: record.UUID,
              });
            });
          }
        });
      }
    });

    /**
     * Strand sárga törlés lokális kezelése
     *
     * @param  Object event
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.TAKE.STRAND_YELLOW, (event) => {
      if (this.player.id !== event.params.selectedPlayer) {
        return;
      }

      if (this.player.cards.red.value && this.player.cards.red.auto) {
        if (this.player.cards.red.value && this.player.cards.red.auto) {
          eventBus.$emit(CONSTANTS.EVENTS.RECORD.DELETE, this.player.cards.red.UUID);
        }

        this.player.cards.red.UUID = undefined;
        this.player.cards.red.value = false;
        this.player.cards.red.auto = false;
      }

      this.player.strandYellows = this.player.strandYellows.filter((yellow) => yellow.UUID !== event.UUID);
      //this.recalculatePlayerStrandYellows();
    });

    /**
     * Ha kijelölnek egy csapatot, akkor a másik csapat játékosait le kell blokkolni
     *
     * @param string|null team A csapat aki ki van jelölve (null esetén nincs kijelölve)
     */
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.TEAM, function (team) {
      self.player.disabled.team = team !== null && team != self.teamid;
    });

    eventBus.$emit("playermounted");
  },
  methods: {
    checkWatch() {
      if (this.$route.meta.header === "report") {
        // Megnézi melyi kiállítás kezdődött el, melyik járt le
        let time = window.stopwatch.getTotalTime();

        // Órák prioritása:
        // * Aktív kiállítás (legfontossabb)
        // * Hátralévő kiállítás kiállítás
        // * Lejárt kiállítás (nincs hozzá óra)

        let status = Infinity;
        let primaryPenalty = undefined;
        let end = 0;
        for (let penalty of this.player.penalties) {

          penalty.isActive = penalty.time.start <= time && time < penalty.time.stop; // [00:00-02:00)
          penalty.finished = penalty.time.stop <= time; // [00:00-02:00)

          // Ikonok beállítása
          if (penalty.isActive) {
            penalty.icon = this.icons.active;
            if (status >= 1) {
              status = 1;
              primaryPenalty = penalty;
            }
            end = primaryPenalty.time.stop;
          } else if (penalty.finished) {
            penalty.icon = this.icons.finished;
          } else {
            penalty.icon = this.icons.pending;
            if (status > 2) {
              status = 2;
              primaryPenalty = penalty;
            }
            if (end && penalty.time.start === end) {
              end = penalty.time.stop;
            }
          }
        }

        switch (status) {
          case 1: // Aktív végére várunk
            this.timeLeft = (end - time);
            debug(this.timeLeft + ' másodperc a jelenlegi kiállítás(ok) végéig');
            this.showCountdown = true;
            break;
          case 2: // Kiállítás kezdetére várunk
            this.timeLeft = (primaryPenalty.time.start - time);
            debug(this.timeLeft + ' másodperc a következő kiállítás kezdetéig');
            this.showCountdown = false;
            break;
          default: // Nem várunk semmire
            this.timeLeft = 0;
            this.showCountdown = false;
        }

        // Megnézzük fut-e az óra
        // Start az fixen kell, hogy mutasson valamit is
        this.timeString = TimeFormatter.intToString(this.timeLeft);
      }
    },
    openGoalKeeperLocalMenu(event) {
      let btn = event.currentTarget.closest('.player-btn').getBoundingClientRect();
      const isMirrored = this.$store.state.ui.isMirrored;
      let rtn = {
        top: btn.top + 8
      };
;
      //pixel törés miatt nem lesz pontosan 0!
      if (btn.left < 2) {
        rtn.left = btn.left + btn.right + 8;
      } else {
        rtn.right = btn.width + 8;
        rtn.right = 0;
      }

      if (this.teamid === 'teamA' || (isMirrored && this.teamid === 'teamB')) {
        rtn.left = rtn.right;
        rtn.left = 0;
        delete rtn.right;
      }

      if (isMirrored && this.teamid === 'teamA') {
        rtn.right = rtn.left;
        delete rtn.left;
      }

      eventBus.$emit(CONSTANTS.EVENTS.SHOWGOALKEEPERMENU, rtn, this.teamid);
    },
    // Megnézi kaphat-e a játékos egy adott lapot
    validateCardAction(type) {
      let actions = {
        piroslap: 'red',
        sargalap: 'yellow',
        keklap: 'blue',
      };

      if (actions[type]) {
        if (!this.player.cards[actions[type]].value) {
          return true;
        } else {
          console.error('Ennek a játékosnak már van ilyen lapja!');
          return false;
        }
      }

      console.error('Nincs ilyen lap!');
      return false;
    },
    validatePenalty(type) {
      let counts = {
        '2perc': 1,
        '4perc': 2,
      };
      if (!counts[type]) {
        console.error('Ilyen kiállítás nem adható!');
        return false;
      }

      let ownPenalty = this.player.penalties.filter((penalty) => !penalty.scapegoat).length;
      if (ownPenalty + counts[type] > 3) {
        console.error('Ezzel együtt a járékosnak több mint 3 kiállítása lenne!');
        return false;
      }

      return true;
    },
    validateKiallitasAction() {
      let ownYellows = this.player.strandYellows.length;
      if (ownYellows > 2) {
        console.error('Ezzel együtt a járékosnak több mint 2 kiállítása lenne!');
        return false;
      }

      return true;
    },
  },
  computed: {
    ...mapState('game', ['timelineData']),
    ...mapGetters('game', ['getAllPlayerStats', 'getActualGoalKeepers']),
    // Ez dönti el, hogy kék legyen-e a játékos neve
    isCurrentGoalKeeper() {
      // 1. Alapvető ellenőrzések: store data és teamid létezése
      if (!this.getActualGoalKeepers || !this.teamid) return false;

      // 2. Kulcs normalizálása ('A' -> 'teamA')
      let teamKey = this.teamid;
      if (teamKey === 'A') teamKey = 'teamA';
      if (teamKey === 'B') teamKey = 'teamB';

      // 3. Kivesszük az értéket a store-ból
      const currentData = this.getActualGoalKeepers[teamKey];

      // 4. Ha null vagy undefined (nincs kapus kijelölve), akkor false
      if (!currentData) return false;

      // 5. Ha Objektum (a képed alapján), akkor a .value mezőt nézzük
      if (typeof currentData === 'object' && currentData.value !== undefined) {
        return currentData.value === this.player.id;
      }

      // 6. Biztonsági tartalék: Ha esetleg mégis csak sima ID lenne (pl. betöltésnél)
      return currentData === this.player.id;
    },
    playerStats() {
      // Ha van statisztika ehhez a játékoshoz, visszaadjuk, ha nincs, nullázott objektumot
      const defaultStats = {
        goals: 0, yellow: false, red: false, blue: false,
        showStrandYellow1: false, showStrandYellow2: false
      };

      if (!this.getAllPlayerStats || !this.player) return defaultStats;

      return this.getAllPlayerStats[this.player.id] || defaultStats;
    },
    isExcluded: function () {
      let rtn = false;

      this.player.penalties.forEach(function (penalty) {
        if (!rtn && penalty.isActive) {
          rtn = true;
        }
      });

      return rtn;
    },
    /**
     * Ha valami miatt le van blokkolva a játékos, akkor azt itt kiszámoljuk
     *
     * Azért computed, mert a többi komponenssel ellentétben ezt nekünk nem befele kell kommunikálnunk,
     * hanem épp azaz, hogy kifelé a PlayerList felé, mivel nem a Player a disabled,
     * hanem az azt tartalmazó v-list-item
     *
     * @return bool Blokkolja-e valami a játékost. Szigorúan bool, ha 0-1 jön vissza, akkor errort kapunk!
     */
    isDisabled() {
      let disabled = false;
      let values = Object.values(this.player.disabled);
      for (let d of values) {
        disabled |= d;
      }
      return !!disabled;
    },
  },
}
</script>

<style>
.v-card.player-btn {
  height: 100%;
  width: 100%;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 100%;

  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  border-style: solid;
  border-left-width: 1px !important;
  border-right-width: 1px !important;
  border-top-width: 0 !important;
  border-bottom-width: 1px !important;
}

.v-card.player-number {
  font-size: 16px;
  font-weight: 900;
  letter-spacing: -0.5px;
  color: #008533 !important;
  min-width: 20px;
  text-align: right;
}

.v-card.player-name {
  font-size: 14px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
}

.v-list-item--disabled .v-card.player-name,
.v-list-item--disabled .v-card.player-number {
  color: #9298af !important;
}

@media only screen and (min-width: 1200px) {
  .v-card.player-name {
    font-size: 16px;
  }
}
</style>

<style scoped>
.goals-shot {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  font-size: 12px;
  line-height: 12px;
  width: 18px;
  height: 26px;
  white-space: nowrap;
}

.goals-shot-gate {
  width: 12px;
  height: 9px;
  margin-bottom: 3px;
  margin-top: 2px;
}

.actual-goalkeeper .v-card.player-number, .actual-goalkeeper .v-card.player-name {
  color: #146aff !important;
}

.isExcluded .player-number {
  color: #F73051 !important;
}
</style>
